import React from 'react'
import { Box, Tab, Tabs } from '@mui/material';

const TabsComponent = ({sx={}, handleTabChange, activeTab, tabLabels, customTabStyle, activeTabStyle, tabsStyle, tabSubText=""}) => {
    const getTabStyle = (index) => ({
        textTransform: 'none',
        color: activeTab === index ? 'var(--primary-color)' : 'var(--text-secondary)',
        width: `${Math.floor(100/tabLabels.length)}%`,
        borderColor: activeTab === index ? 'var(--primary-color)' : 'var(--borderColor)',
        ...customTabStyle,
        ...(activeTab === index ? activeTabStyle : {})
    });

    const tabStyle = {
        height: '32px',
        minHeight: '32px',
        textTransform: 'none',
        color: 'var(--text-secondary)',
        backgroundColor: 'transparent',
        fontSize: "13px",
        fontWeight: 600, 
        overflow: 'hidden',
        whiteSpace: 'nowrap',
    };

    return (
        <Box sx={{width: "auto", ...sx}}>
            <Tabs
                value={activeTab}
                onChange={handleTabChange}
                indicatorColor="grey"
                sx={{
                    marginTop: '10px',
                    height: '32px',
                    minHeight: '32px',
                    ...tabsStyle
                }}
                TabIndicatorProps={{
                    style: { background: 'var(--primary-color)' }
                }}
                variant="scrollable"
                scrollButtons="auto"
            >
                {tabLabels.map((label, index) => {
                    const style = {
                        ...tabStyle,
                        ...getTabStyle(index),
                    }
                    return (
                        <Tab
                            key={label}
                            label={`${label}${index === activeTab ? tabSubText : ""}`}
                            style={style}
                        />
                    )
                })}
            </Tabs>
        </Box>
    )
}

export default TabsComponent;
